import React, { useState, useEffect } from "react";
import defaultImage from "../../assets/default.jpg";
import moment from "moment";
import { Link } from "react-router-dom";
import { getStatus2 } from "../../misc/misc";
import NavTab from "./NavTab";
import classNames from "classnames";
import classes from "./styles.module.scss";

import Countdown from "react-countdown";
// import keyArt from '../../assets/Cover_KeyArt_FB_828x315px.png';
// import fintech from '../../assets/wsi-imageoptim-fintech-e1510823390462.jpeg';
// import fintechStage from '../../assets/fintech-stage.jpg';

export default ({
  listEvent,
  pastEvent,
  comingEvent,
  baseURL,
  changeCategory,
  eventType
}) => {
  const [activePage, setActivePage] = useState("coming");
  const [newList, setNewList] = useState(listEvent);

  const countDown = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      return null;
    } else {
      return (
        <p class="text-muted">
          {days}h {hours}j {minutes}m {seconds}d
        </p>
      );
    }
  };
  useEffect(() => {
    // console.log("new =>", newList);
    // console.log("coming =>", comingEvent);
    // console.log("past =>", pastEvent);
    if (activePage === "coming") {
      setNewList(comingEvent);
    } else {
      setNewList(pastEvent);
    }
  }, [activePage, newList, comingEvent, pastEvent, listEvent]);

  // useEffect(() => {
  //   if (activePage === "coming") {
  //     setNewList(comingEvent);
  //   } else {
  //     setNewList(pastEvent);
  //   }
  // }, [comingEvent]);

  // useEffect(() => {
  //   setNewList(listEvent)
  // }, [listEvent])

  return (
    <section className="akun-saya" style={{ borderBottom: 'none'}}>
      <div className="container">
        <NavTab activePage={activePage} setActivePage={setActivePage} />
        <select
          className={classNames(
            "select-primary form-control",
            classes.selectionCategory
          )}
          onChange={changeCategory}
        >
          {/* <option hidden="" selected="">Jumlah</option> */}
          <option hidden value="1">
            Pilih Kategori Acara
          </option>
          <option value="" selected={eventType === ""}>
            Semua
          </option>
          <option value="event" selected={eventType === "event"}>
            Event
          </option>
          <option value="webinar" selected={eventType === "webinar"}>
            Webinar
          </option>
        </select>
        <div className="row" style={{ flexWrap: "wrap", overflowX: "auto" }}>
          {listEvent.length > 0 ? (
            listEvent.map(e => {
              return (activePage === 'coming' ? getStatus2(e.endDate) === 1 : getStatus2(e.endDate) !==1) && (
              <div
                className={classNames(
                  "col-lg-4 col-md-4 col-sm-10 col-10",
                  classes.eventCard
                )}
              >
                <div
                  className={classNames(classes.typeEvent, {
                    [classes.webinar]: e.eventType === "webinar"
                  })}
                >
                  <p>
                    {e.eventType === "webinar" ? "Live Webinar" : e.eventType}
                  </p>
                </div>
                <img
                  className="mb-4"
                  src={e.picture ? baseURL + "/" + e.picture : defaultImage}
                  alt="grey"
                  style={{
                    width: "100%",
                    height: "150px",
                    objectFit: "cover"
                  }}
                />
                <div className="d-flex">
                  <div className="text-center">
                    <p
                      style={{
                        fontSize: "18px",
                        color: "#15A325",
                        fontWeight: "600"
                      }}
                    >
                      {moment(e.startDate).format("MMMM")}
                    </p>
                    <p style={{ fontSize: "18px", fontWeight: "600" }}>
                      {moment(e.startDate).format("DD")}
                    </p>
                  </div>
                  <div className="ml-5">
                    <Link
                      to={`/event_detil/${e._id}`}
                      style={{ color: "black" }}
                    >
                      <p style={{ fontSize: "18px", fontWeight: "600" }}>
                        {e.title}
                      </p>
                    </Link>
                    <p className="text-muted">
                      {moment(e.startDate).format("ddd, MMMM DD")},{" "}
                      {e.startTime}
                    </p>
                    <p className="text-muted">{e.location}</p>
                    <Countdown
                      date={new Date(
                        `${moment(e.startDate).format("MMM DD, YYYY")} ${
                          e.startTime
                        }:00`
                      ).getTime()}
                      renderer={countDown}
                    />
                    <p style={{ fontSize: "16px", fontWeight: "600" }}>
                      GRATIS
                    </p>
                  </div>
                </div>
              </div>
            )
            })
          ) : (
            <div>No data founded</div>
          )}
        </div>
      </div>
    </section>
  );
};
